/**
 * Build a stable Drive image URL served through our own proxy so it
 * never expires. Falls back to Drive's short-lived thumbnailLink if
 * we don't have the file id.
 */
export function driveImgSrc(driveFileId: string | null | undefined, fallbackLink?: string | null, size: number = 400): string | null {
  if (driveFileId) return `/api/drive-image/${driveFileId}?size=${size}`;
  return fallbackLink ?? null;
}
